import { fromJS } from 'immutable';
export default function (original, override) {
  // eslint-disable-line require-jsdoc
  var globals = original.get('globals').mergeDeep(override.get('globals'));
  var extendedGlobals = original.set('globals', globals);
  return override.reduce(function (acc, value, key) {
    return key === 'globals' ? acc : acc.set(key, function (globals) {
      return extendedGlobals.get(key) ? returnMap(extendedGlobals.get(key), globals).mergeDeep(returnMap(value, globals)) : returnMap(value, globals);
    });
  }, extendedGlobals);
}

function returnMap(funcOrMap, globals) {
  // eslint-disable-line require-jsdoc
  return fromJS(typeof funcOrMap === 'function' ? funcOrMap(globals) : funcOrMap);
}